import { AxiosInstance } from 'axios'

import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse, PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import {
  GetNonprofitsProps,
  NonprofitsType,
  Organisation,
  OrganisationSearchResult,
  Registry
} from './nonprofitsService.types'

type ValidationsServiceCapabilities = {
  percentClient: AxiosInstance
}

export const nonprofitsService = ({ percentClient }: ValidationsServiceCapabilities) => ({
  getNonProfits: (params: GetNonprofitsProps) =>
    percentClient.get<PBPListResponse<NonprofitsType>>(`${baseUrl}organisations-summary`, { params }),
  getNonprofit: ({ id }: { id: string | null }) =>
    percentClient.get<PBPResponse<Organisation>>(`${baseUrl}organisations/${id}`),
  getWorkplaceOrganisations: (params: { query: string; pageSize?: number; countryCode?: string }) =>
    percentClient.get<PBPListResponse<OrganisationSearchResult>>(`${baseUrl}workplace/organisations`, { params }),
  getOrganisations: (params: { query: string; pageSize?: number; countryCode?: string }) =>
    percentClient.get<PBPListResponse<Organisation>>(`/v1/organisations`, { params }),
  getRegistries: (params: { countryCode: string; supportedTypes?: string[] }) =>
    percentClient.get<PBPResponse<Registry[]>>(`/v1/registries`, { params })
})
